import PolarisAssistantAPI from 'dashboard/api/polaris/assistant';

// O progresso dos 6 passos do Get started de cada assistente (GET setup_status, calculado a cada chamada).
// Alimenta os pontos de status do menu, a barra "Passo N de 6" do PageLayout e a checklist do Get started.
export const state = () => ({
  byAssistant: {},
});

export const getters = {
  getStatus: store => assistantId =>
    store.byAssistant[Number(assistantId)] || null,
};

export const mutations = {
  setStatus(store, { assistantId, status }) {
    store.byAssistant = { ...store.byAssistant, [Number(assistantId)]: status };
  },
};

export const actions = {
  // Dedup: vários componentes da mesma página (seletor da sidebar, PageLayout, Get started) pedem o mesmo
  // status; quem já tem dados não refaz o GET. Quem acabou de mudar um passo (ex.: Integrações visitada)
  // força o refetch com { force: true }.
  async fetch({ state: loaded, commit }, assistantId, { force = false } = {}) {
    const cached = loaded.byAssistant[Number(assistantId)];
    if (!force && cached) return cached;
    const { data } = await PolarisAssistantAPI.getSetupStatus(assistantId);
    commit('setStatus', { assistantId, status: data });
    return data;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
